import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { 
    LayoutDashboard, 
    ClipboardList, 
    Users,
    CalendarDays,
    UserCircle,
    Clock,
    Palmtree,
    MapPin,
    Menu
} from 'lucide-react';

export const MobileNav = () => {
    const { isAdmin } = useAuth();

    const adminLinks = [
        { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
        { to: '/my-orders', icon: ClipboardList, label: 'Aufträge' },
        { to: '/live-tracking', icon: MapPin, label: 'Tracking' },
        { to: '/time-management', icon: Clock, label: 'Zeiten' },
        { to: '/more', icon: Menu, label: 'Mehr' },
    ];

    const employeeLinks = [
        { to: '/my-orders', icon: ClipboardList, label: 'Aufträge' },
        { to: '/calendar', icon: CalendarDays, label: 'Kalender' },
        { to: '/time-tracking', icon: Clock, label: 'Zeiten' },
        { to: '/vacation', icon: Palmtree, label: 'Urlaub' },
        { to: '/profile', icon: UserCircle, label: 'Profil' },
    ];

    const links = isAdmin() ? adminLinks : employeeLinks;

    return (
        <nav className="fixed bottom-0 left-0 right-0 bg-card border-t show-mobile-only z-50" data-testid="mobile-nav">
            <div className="flex justify-around items-center py-1">
                {links.map((link) => (
                    <NavLink
                        key={link.to}
                        to={link.to}
                        className={({ isActive }) =>
                            `mobile-nav-item ${isActive ? 'active' : ''}`
                        }
                        data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                        <link.icon className="h-5 w-5" strokeWidth={1.5} />
                        <span className="text-xs mt-1">{link.label}</span>
                    </NavLink>
                ))}
            </div>
        </nav>
    );
};

export default MobileNav;
